import { Button } from "../../../../core/components/Button";
import { Column } from "../../../../core/components/Column";
import { Label } from "../../../../core/components/Label";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { ArrowRightIcon } from "../../../../core/icons/ArrowRight";
import { UnLink } from "../../../../core/icons/UnLink";

export const Publish: React.FC<{
	title: string;
	description: string;
	listParticipant: string[];
	listPrizes: string[];
	loading: boolean;
	date: string;
	hour: string;
	createLottery: () => void;
	back: () => void;
}> = ({ title, description, listParticipant, listPrizes, loading, date, hour, back, createLottery }) => {
	const renderResumen = (label: string, text: string | string[]) => {
		return (
			<Column
				className="px-3 py-2 shadow"
				flexible
			>
				<p className="text-sm text-gray-500 sm:text-md">
					{label} {!text && <span className="text-gray-500">Sín Específicar</span>}
				</p>
				{text && (
					<>
						{typeof text === "string" ? (
							<p className="text-sm md:text-base truncate">{text}</p>
						) : (
							<Row
								className="gap-1 md:gap-2"
								responsiveWrap
							>
								<Label
									items={text}
									color="gray"
									secondary
								/>
							</Row>
						)}
					</>
				)}
			</Column>
		);
	};
	return (
		<>
			<Column className="gap-2 md:gap-4">
				<TextComponent
					variant="h2"
					className="font-bold text-orange-500 uppercase text-center"
				>
					Resumen del sorteo público
				</TextComponent>
				<Column className="gap-3 md:gap-4">
					{renderResumen("Título:", title)}
					{renderResumen("Descripción:", `${description}`)}
					{renderResumen("Participantes:", listParticipant)}
					{renderResumen("Premios:", listPrizes)}
					<Row
						className="gap-3 md:gap-4"
						flexible
					>
						{renderResumen("Fecha:", date)}
						{renderResumen("Hora:", hour)}
					</Row>
				</Column>
			</Column>
			<Column className="w-full gap-2">
				<Row
					className="gap-2 font-bold"
					flexible
					responsiveCol
				>
					<Button
						className="md:w-1/2"
						color="yellow"
						onClick={back}
					>
						<Row
							className="gap-1"
							crossAxisAlignment="center"
							mainAxisAlignment="center"
						>
							<ArrowRightIcon className="w-5 h-5 rotate-180" />
							<span>Atrás</span>
						</Row>
					</Button>
					<Button
						className="md:w-1/2 max-md:order-first"
						onClick={createLottery}
						isLoading={loading}
						sizeLoading="w-5 h-5"
						color="orange"
						secondary
					>
						<Row
							className="gap-1"
							crossAxisAlignment="center"
							mainAxisAlignment="center"
						>
							<UnLink className="w-5 h-5" />
							<span>Crear sorteo público</span>
						</Row>
					</Button>
				</Row>
			</Column>
		</>
	);
};
